//function to convert string to camel case
export const camelCase = (str) => {
    // the first letter of the string is always lowercase

    // split the string into words
    let words = str.split(" ");
    // capitalize the first letter of each word except the first word
    for (let i = 1; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].slice(1);
    }
    //lowercase first letter of first word
    words[0] = words[0].toLowerCase();
    // join the words
    return words.join("");

    
};
    